import React, { useEffect, useState } from 'react';
import { Flex, Typography } from 'antd';
import './style.scss';
import UploadExcelFile from '../UploadExcelFile/UploadExcelFile';
import { RestBids } from '../../services/rest_bids';
import useModalMessage from '../../hooks/useModalMessage';
import { useTranslation } from "react-i18next";

interface HeaderContentComponentProps {
  arButton?: () => React.JSX.Element;
  title?: string;
  locale?: any;
  setDataAllBids: (res: any) => any;
}

const keysRentString = [
  'created_at',
  'department',
  'country1',
  'city1',
  'country2',
  'city2',
  'col_ktk',
  'type_ktk',
  'quality',
  'bet',
  'symbol',
  'subsidy',
  'bet_1_crane',
  'bet_1_day',
  'free_days',
  'cnp',
  'comment',
];
const keysRent: any = {
  created_at: 'Дата обновления',
  department: 'Услуга',
  country1: 'Страна выдачи',
  city1: 'Город выдачи',
  country2: 'Страна сдачи',
  city2: 'Город сдачи',
  col_ktk: 'Кол-во КТК',
  type_ktk: 'Тип КТК',
  quality: 'Качество',
  bet: 'Ставка',
  subsidy: 'Субсидия',
  bet_1_crane: 'Ставка 1 кран',
  bet_1_day: 'Ставка 1 день',
  free_days: 'Свободные дни',
  cnp: 'СНП',
  comment: 'Комментарии',
};

const Index = ({
  arButton,
  title,
  locale,
  setDataAllBids,
}: HeaderContentComponentProps) => {
  const [duplicateIs, setDuplicateIs] = useState<boolean>(false);
  const isDuplicate = sessionStorage.getItem('duplicate');
  const message = useModalMessage(true);
  const {t, i18n} = useTranslation();

  useEffect(() => {
    if (isDuplicate) {
      setDuplicateIs(Boolean(isDuplicate));
    } else {
      setDuplicateIs(true);
    }
  }, []);

  // импорт по шаблону аренды
  const handlerExlRent = (arr: any[]) => {
    const result = arr.slice(1).map((el, ind) => ({ ...el, index: ind + 2 }));

    RestBids.updateBidsRent({ data: result, locale: locale })
      .then((res) => {
        const data = res?.data;
        if (data?.rows) {
          setDataAllBids((prev: any[]) => [...data.rows, ...prev]);
        } else {
          const result: string[] = data?.map((el: {index: string, [key: string]: string}) => {
            for (const key in keysRent) {
              if (el?.[key]) {
                return `Строка №${el?.['index']?? ''}- ${keysRent[key]} ( ${el?.[key]} )`
              }
            }
          }).filter((el: string | undefined) => el);
          message.error('Ошибки в файле:' + ' '.repeat(20) + result.join(';' + ' '.repeat(5)), 0);
        }
      }).catch((err) => {
        console.log('err', err);
      });
  };

  return (
    <Flex justify="space-between" align="center" className={'bids__box'}>
      <div>
        <Typography.Title level={4}>{title}</Typography.Title>
      </div>
      <div style={{ color: 'red' }}>
        {!duplicateIs ? 'Обратите внимание есть дубли городов или стран' : ''}
      </div>
      <Flex gap={16} align={'flex-end'} style={{ height: 47 }}>
        <UploadExcelFile
          nameLink={t('DownloadFromExcel')}
          styleButton={{padding: '5px 15px'}}
          keyNames={keysRentString}
          onChange={handlerExlRent}
        />
        {arButton ? arButton() : null}
      </Flex>
    </Flex>
  );
};

export default Index;
